import { render, staticRenderFns } from "./UcContactFieldset.yaml?vue&type=template&id=3e7aafc4&component"
import script from "./UcContactFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./UcContactFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports